import "core-js/modules/es6.function.name";
//
//
//
//
import echarts from 'echarts';
import tdTheme from './theme.json';
import { on, off } from '@/libs/tools';
import { chartMixins } from './chartMixins';
echarts.registerTheme('tdTheme', tdTheme);
export default {
  name: 'ChartPie',
  mixins: [chartMixins],
  props: {
    value: Array,
    text: String,
    subtext: String
  },
  data: function data() {
    return {
      dom: null
    };
  },
  methods: {
    resize: function resize() {
      this.dom.resize();
    },
    setParams: function setParams(value) {
      var legend = value.map(function (_) {
        return _.name;
      });
      this.option = {
        title: {
          text: this.showTitle ? this.text : '',
          subtext: this.subtext,
          x: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          // type: 'scroll',
          //orient: 'vertical',
          left: 'center',
          top: '6%',
          data: legend,
          pageIconColor: '#fff',
          textStyle: {},
          pageTextStyle: {
            color: '#fff'
          }
        },
        series: [{
          type: 'pie',
          name: this.text,
          radius: '50%',
          center: ['50%', '55%'],
          data: this.value,
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      };
      return this.option;
    },
    init: function init() {
      this.dom = echarts.init(this.$refs.dom, 'tdTheme');
      this.dom.setOption(this.setParams(this.value));
      on(window, 'resize', this.resize);
    },
    setOption: function setOption(value) {
      this.dom.setOption(this.setParams(value));
    }
  },
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    off(window, 'resize', this.resize);
  }
};